import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IfRoleDirective, Role } from '@core/auth/if-role.directive';
import { LanguageSelectorComponent } from '@core/i18n/selector/selector.component';
import { SessionManagementComponent } from '@core/auth/session-management/session-management.component';
import { TranslocoDirective } from '@jsverse/transloco';

type NavItem = {
  id: string;
  route: string;
  labelKey: string;
  role: Role;
};

const navItems: NavItem[] = [
  { id: 'home', route: '/home', labelKey: 'nav.dashboard', role: 'admin' },
  { id: 'gezinnen', route: '/gezin-overzicht', labelKey: 'nav.family-overview', role: 'monitor' },
  { id: 'kinderen', route: '/kind-overzicht', labelKey: 'nav.child-overview', role: 'monitor' },
  { id: 'volunteers', route: '/vrijwilliger-overzicht', labelKey: 'nav.volunteers', role: 'admin' },
  { id: 'lijsten', route: '/lijsten', labelKey: 'nav.attendance-records', role: 'monitor' },
  { id: 'kosten', route: '/kosten', labelKey: 'nav.add-costs', role: 'beheerder' },
  { id: 'wachtlijst', route: '/wachtlijsten', labelKey: 'nav.waitinglists', role: 'beheerder' },
  { id: 'activities', route: '/activiteit-overzicht', labelKey: 'nav.activities', role: 'monitor' },
  { id: 'users', route: '/users', labelKey: 'nav.user-invitation', role: 'admin' },
  { id: 'self-checkin', route: '/self-checkin', labelKey: 'nav.self-checkin', role: 'kind' },
  {
    id: 'self-checkin-volunteer',
    route: '/self-checkin-volunteer',
    labelKey: 'nav.self-checkin',
    role: 'volunteer-tablet',
  },
];

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    NgbCollapse,
    RouterLink,
    RouterLinkActive,
    IfRoleDirective,
    LanguageSelectorComponent,
    SessionManagementComponent,
    TranslocoDirective,
  ],
})
export class NavbarComponent {
  protected readonly title = 'Infano';
  protected readonly isMenuCollapsed = signal(true);
  protected readonly navItems = navItems;

  toggleMenu(): void {
    this.isMenuCollapsed.update((v) => !v);
  }

  closeMenu(): void {
    this.isMenuCollapsed.set(true);
  }
}
